import React from 'react';
import ActionBoxContainer from './components/ActionBoxContainer';
import Page from '../../components/UI/layout/Page';
import OtpModal from './components/modals/otp-modal/Otp.modal';
import CheckReqStatusModal from './components/modals/CheckReqStatus.modal';
import CancelPermitModal from './components/modals/CancelPermit.modal';
import CheckPermitStatusModal from './components/modals/CheckPermitStatus.modal';
import RenewedPermitModal from './components/modals/renewed-permit-modal/RenewedPermit.modal';
import UpdateVehicleModal from './components/modals/update-vehicle-modal/UpdateVehicle.modal';
import AddFileModal from './components/modals/AddFile.modal';



const HomePage = () => {

    return (
        <Page
            modals={(
                <>
                    <OtpModal />
                    <AddFileModal />
                    <CheckReqStatusModal />
                    <CancelPermitModal />
                    <CheckPermitStatusModal />
                    <RenewedPermitModal />
                    <UpdateVehicleModal />
                </>
            )}
        >
            <ActionBoxContainer />
        </Page>
    );
}

export default HomePage;